export function checkSsn(ssn) {
  let match = false;
  ssn = ssn.trim();
  if (
    ssn.length == 13 &&
    (ssn.startsWith("19") || ssn.startsWith("20")) &&
    ssn.indexOf("-") == 8
  ) {
    ssn = ssn.replace("-", "");
    match = true;
  } else if (
    ssn.length == 12 &&
    (ssn.startsWith("19") || ssn.startsWith("20"))
  ) {
    match = true;
  }

  if (match && isNaN(ssn)) {
    match = false;
  }
  if (match && !SSNChecksum(ssn)) {
    match = false;
  }

  return match;
}

function SSNChecksum(number) {
  let sum = number
    .substr(2)
    .split("")
    .map((el, index) => {
      if (index % 2 == 0) {
        return ((parseInt(el) * 2) % 10) + Math.floor(parseInt(el) / 5);
      } else {
        return parseInt(el);
      }
    })
    .reduce((a, b) => {
      return a + b;
    });

  return sum % 10 == 0;
}
